import { useEffect } from "react";
import { sentryService } from "../../utils/sentry-service";
import { useMyInfo } from "../../hooks/user.hooks";
import { useCompanyInfo } from "../../hooks/company.hooks.ts";

const SentryIdentity = () => {
  const { data: myInfo } = useMyInfo();
  const { data: companyInfo } = useCompanyInfo();

  useEffect(() => {
    if (myInfo) {
      const { id, email, firstName, lastName } = myInfo;
      const fullName = `${firstName || ""} ${lastName || ""}`.trim();

      const domain = companyInfo?.domain || "root";

      // Set user context
      sentryService.setUser({
        id,
        email,
        username: fullName,
        company_domain: domain,
      });

      // Set tags
      sentryService.setTag("company_domain", domain);
      sentryService.setTag("app", "backoffice");

      const releaseVersion = process.env.GATSBY_APP_VERSION || "unknown";
      sentryService.setTag("release_version", releaseVersion);
    }
  }, [myInfo, companyInfo]);

  return null;
};

export default SentryIdentity;
